import {
    CANCEL_VAS, CHANGE_DISCOUNT_CODE,
    CHANGE_SELECTED_COVER_LETTERS, CHANGE_SELECTED_CURRENCY,
    CHANGE_SELECTED_DOCTYPE,
    CHANGE_SELECTED_LEVEL,
    CHANGE_SELECTED_URGENCY, CHANGE_VAS_ITEMS, CLEAR_DISCOUNT_CODE, RECEIVE_CHECK_DISCOUNT_RESPONSE, SELECT_VAS
} from "../actions";

const initialState = {
    selectedDoctypeId: window.orderFormInitialState.doctypeId,
    selectedLevelName: window.orderFormInitialState.wrlevelName,
    selectedUrgencyId: window.orderFormInitialState.urgencyId,
    selectedCurrency: window.orderFormInitialState.currency,
    selectedCoverLettersCount: window.orderFormInitialState.selectedCoverLettersCount,
    selectedVasIds: window.orderFormInitialState.selectedVasIds || [],
    selectedVasItems: window.orderFormInitialState.selectedVasItems || {},
    discountCode: window.orderFormInitialState.discountCode || '',
    discountPercent: 0,
    discountValue: 0,
    isDiscountValid: true,
    needDiscountInitialCheck: window.orderFormInitialState.discountCode && window.orderFormInitialState.discountCode.length > 0,
}

const orderDetails = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_SELECTED_DOCTYPE:
            return Object.assign({}, state, {
                selectedDoctypeId: parseInt(action.doctypeId)
            });
        case CHANGE_SELECTED_COVER_LETTERS:
            return Object.assign({}, state, {
                selectedCoverLettersCount: parseInt(action.coverLetters),
            })
        case CHANGE_SELECTED_LEVEL:
            return Object.assign({}, state, {
                selectedLevelName: action.levelName
            });
        case CHANGE_SELECTED_URGENCY:
            return Object.assign({}, state, {
                selectedUrgencyId: parseInt(action.urgencyId)
            });
        case CHANGE_SELECTED_CURRENCY:
            return Object.assign({}, state, {
                selectedCurrency: action.currency
            })
        case SELECT_VAS:
            return Object.assign({}, state, {
                selectedVasIds: [...state.selectedVasIds, parseInt(action.vasId)]
            })
        case CANCEL_VAS:
            return Object.assign({}, state, {
                selectedVasIds: state.selectedVasIds.filter(vasId => vasId !== parseInt(action.vasId))
            })
        case CHANGE_VAS_ITEMS:
            return Object.assign({}, state, {
                selectedVasItems: Object.assign({}, state.selectedVasItems, {
                    [action.vasId]: action.itemsCount,
                }),
            })
        case CLEAR_DISCOUNT_CODE:
            return Object.assign({}, state, {
                discountCode: '',
                discountValue: 0,
                discountPercent: 0,
                isDiscountValid: true,
            })
        case CHANGE_DISCOUNT_CODE:
            return Object.assign({}, state, {
                discountCode: action.discountCode,
                isDiscountValid: true,
            })
        case RECEIVE_CHECK_DISCOUNT_RESPONSE:
            return Object.assign({}, state, {
                isDiscountValidation: false,
                needDiscountInitialCheck: false,
                discountPercent: action.discountPercent,
                isDiscountValid: action.discountPercent > 0,
            })
        default:
            return state
    }
}

export default orderDetails